import { createSlice } from "@reduxjs/toolkit";
import {
  addCategory,
  deleteCategory,
  getCategories,
  updateCategory,
} from "../apiActions/categoryAction";
import handleApiMessage from "../../utils/handleApiError";

type Category = {
  id: string;
  created_at: string;
  name: string;
};

type CategoryState = {
  categories: Category[];
  error: null | string;
  loading: {
    getCategory: boolean;
    addCategory: boolean;
    deleteCategory: boolean;
    updateCategory: boolean;
  };
};
const initialState: CategoryState = {
  categories: [],
  error: null,
  loading: {
    getCategory: false,
    addCategory: false,
    deleteCategory: false,
    updateCategory: false,
  },
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state: CategoryState) => {
        state.loading.getCategory = true;
        state.error = null;
      })
      .addCase(getCategories.fulfilled, (state: CategoryState, action) => {
        state.loading.getCategory = false;
        state.error = null;
        state.categories = action.payload;
      })
      .addCase(getCategories.rejected, (state: CategoryState, action: any) => {
        state.loading.getCategory = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(addCategory.pending, (state: CategoryState) => {
        state.loading.addCategory = true;
        state.error = null;
      })
      .addCase(addCategory.fulfilled, (state: CategoryState, action) => {
        state.loading.addCategory = false;
        state.error = null;
      })
      .addCase(addCategory.rejected, (state: CategoryState, action: any) => {
        state.loading.addCategory = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(deleteCategory.pending, (state: CategoryState) => {
        state.loading.deleteCategory = true;
        state.error = null;
      })
      .addCase(deleteCategory.fulfilled, (state: CategoryState, action) => {
        state.loading.deleteCategory = false;
        state.error = null;
      })
      .addCase(deleteCategory.rejected, (state: CategoryState, action: any) => {
        state.loading.deleteCategory = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(updateCategory.pending, (state: CategoryState) => {
        state.loading.updateCategory = true;
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state: CategoryState, action) => {
        state.loading.updateCategory = false;
        state.error = null;
      })
      .addCase(updateCategory.rejected, (state: CategoryState, action: any) => {
        state.loading.updateCategory = false;
        handleApiMessage(action.payload.description, "error");
      });
  },
});

// export const {} = categorySlice.actions;
export default categorySlice.reducer;
